import {certificateElementType} from "~/enums/certificateElementType";
import {certificateElementCapability} from "./certificateElementCapability";
import assertNever from "../../../global/assetNever";
import {DynamicListFormatType} from "~/enums/dynamicListFormatType";
import {FontType} from "~/enums/fontType";
import {DynamicListOrderType} from "~/enums/dynamicListOrderType";
import {DynamicListBulletStyle} from "~/enums/dynamicListBulletStyle";
import {HorizontalAlignment, VerticalAlignment} from "~/enums/certificates/alignment";
import {CertificateSize} from "../enums/certificateSize";
import {CertificateOrientation} from "../enums/certificateOrientation";

export default class CertificateElementCapabilityManager {
  static debug: boolean = false;


  static SIZEABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Text,
    certificateElementType.Image,
    certificateElementType.DynamicImage,
    certificateElementType.DynamicSignature,
    certificateElementType.DynamicList,
    certificateElementType.DynamicModeImage,
    certificateElementType.DynamicModeDynamicImage,
    certificateElementType.DynamicModeDynamicSignature,
  ]

  static MERGEABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.GridCell
  ]

  static DIMENSIONABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Text,
    certificateElementType.Image,
    certificateElementType.DynamicImage,
    certificateElementType.DynamicList,
    certificateElementType.DynamicSignature,

  ];

  static DRAGGABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Text,
    certificateElementType.Image,
    certificateElementType.DynamicImage,
    certificateElementType.DynamicList,
    certificateElementType.DynamicSignature,

  ]

  static WYSIWYGABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.DynamicModeText,
    certificateElementType.Text
  ]
  static CONTAINERABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Grid,
    certificateElementType.Stack,
  ]

  static LAYOUTABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Grid,
    certificateElementType.Stack,
    certificateElementType.Divider,
    certificateElementType.PageBreak
  ]

  static RESIZEABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Text,
    certificateElementType.Image,
    certificateElementType.DynamicImage,
    certificateElementType.DynamicSignature,
    certificateElementType.DynamicList,
    certificateElementType.DynamicModeImage,
    certificateElementType.DynamicModeDynamicImage,
    certificateElementType.DynamicModeDynamicSignature,
  ]

  static OPACITYABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Text,
    certificateElementType.Image,
    certificateElementType.DynamicImage,
    certificateElementType.DynamicSignature,
    certificateElementType.DynamicModeImage,
    certificateElementType.DynamicModeDynamicImage,
    certificateElementType.DynamicModeText,
    certificateElementType.DynamicModeDynamicList,
    certificateElementType.DynamicModeDynamicSignature,
    certificateElementType.Grid,
    certificateElementType.Stack,
    certificateElementType.Divider,
  ];

  static ALIGNABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Text,
    certificateElementType.Image,
    certificateElementType.DynamicImage,
    certificateElementType.DynamicSignature,
    certificateElementType.DynamicList,
    certificateElementType.DynamicModeDynamicImage,
    certificateElementType.DynamicModeImage,
    certificateElementType.DynamicModeDynamicList,
    certificateElementType.DynamicModeDynamicSignature,
    certificateElementType.Grid,
    certificateElementType.Stack,
    certificateElementType.Divider,
  ];

  static BACKGROUND_COLORABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Text,
    certificateElementType.DynamicList,
    certificateElementType.DynamicModeText,
    certificateElementType.DynamicModeDynamicList,
    certificateElementType.Grid,
    certificateElementType.Stack,
    certificateElementType.Divider,
  ];

  static DYNAMIC_IMAGEABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.DynamicImage,
    certificateElementType.DynamicModeDynamicImage,
    certificateElementType.DynamicSignature,
    certificateElementType.DynamicModeDynamicSignature,
  ];

  static IMAGEABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.DynamicModeImage,
    certificateElementType.Image
  ]

  static PAGEABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Page,
  ];

  static TRANSFORMABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Text,
    certificateElementType.Image,
    certificateElementType.DynamicImage,
    certificateElementType.DynamicList,
    certificateElementType.DynamicSignature,
  ];

  static LABELABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.AdaptiveLayoutSection,
  ];

  static DYNAMIC_LISTABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.DynamicList,
    certificateElementType.DynamicModeDynamicList
  ];

  static MOVE_DESTROYABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Grid,
    certificateElementType.Stack,
    certificateElementType.Divider,
    certificateElementType.PageBreak
  ];
  static ROTATEABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Text,
    certificateElementType.Image,
    certificateElementType.DynamicImage,
    certificateElementType.DynamicSignature,
    certificateElementType.DynamicList,
    certificateElementType.DynamicModeImage,
    certificateElementType.DynamicModeDynamicImage,
    certificateElementType.DynamicModeDynamicSignature,

  ]
  static FILLABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Text,
    certificateElementType.DynamicModeText,
    certificateElementType.DynamicList,
    certificateElementType.DynamicModeDynamicList,
    certificateElementType.Grid,
    certificateElementType.Stack,
  ]

  static RELATIVELY_ALIGNABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.DynamicModeDynamicImage,
    certificateElementType.DynamicModeImage,
    certificateElementType.DynamicModeDynamicList,
    certificateElementType.DynamicModeText,
    certificateElementType.Grid,
    certificateElementType.Stack,
    certificateElementType.Divider,
  ]

  static NON_DISPLAY_LAYOUT_CONTROLS: certificateElementType[] = [
    certificateElementType.PageBreak,
    certificateElementType.AdaptiveLayoutSection,
  ]

  static WIDTHABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Grid,
    certificateElementType.Stack,
    certificateElementType.Divider,
  ]

  static REPEATABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Grid,
    certificateElementType.Stack,
  ]

  static PADDINGABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Grid,
    certificateElementType.Stack,
    certificateElementType.Divider,
  ]

  static MARGINABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Grid,
    certificateElementType.Stack,
  ]

  static OUTLINE_THICKNESSABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Grid,
    certificateElementType.Stack,
  ]

  static LINEABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Divider,
  ]
  static PREVIEWABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.AdaptiveLayoutSection
  ]

  static PAGESIZEABLE_CONTROLS: certificateElementType[] =[
    certificateElementType.AdaptiveLayoutSection
  ]

  static LAYOUT_DRAGGABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.Grid,
    certificateElementType.Stack,
    certificateElementType.Divider,
    certificateElementType.PageBreak,
    certificateElementType.GridCell

  ]

  static Page_MARGINABLE_CONTROLS: certificateElementType[] = [
      certificateElementType.AdaptiveLayoutSection
  ]

  static PAGE_NUMBERABLE_CONTROLS: certificateElementType[] = [
    certificateElementType.AdaptiveLayoutSection
  ]

  static can(type: certificateElementType, duty: certificateElementCapability) {
    let can: boolean = false;
    switch (duty) {
      case certificateElementCapability.dimensionable:
        can = CertificateElementCapabilityManager.DIMENSIONABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.sizeable:
        can = CertificateElementCapabilityManager.SIZEABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.alignable:
        can = CertificateElementCapabilityManager.ALIGNABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.backgroundColorable:
        can = CertificateElementCapabilityManager.BACKGROUND_COLORABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.dynamicImageable:
        can = CertificateElementCapabilityManager.DYNAMIC_IMAGEABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.pageable:
        can = CertificateElementCapabilityManager.PAGEABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.transformAble:
        can = CertificateElementCapabilityManager.TRANSFORMABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.dynamicListable:
        can = CertificateElementCapabilityManager.DYNAMIC_LISTABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.opacityAble:
        can = CertificateElementCapabilityManager.OPACITYABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.resizeable:
        can = CertificateElementCapabilityManager.RESIZEABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.draggable:
        can = CertificateElementCapabilityManager.DRAGGABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.moveDestroyable:
        can = CertificateElementCapabilityManager.MOVE_DESTROYABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.containerAble:
        can = CertificateElementCapabilityManager.CONTAINERABLE_CONTROLS.includes(type);
        break
      case certificateElementCapability.layoutAble:
        can = CertificateElementCapabilityManager.LAYOUTABLE_CONTROLS.includes(type);
        break
      case certificateElementCapability.rotateable:
        can = CertificateElementCapabilityManager.ROTATEABLE_CONTROLS.includes(type);
        break
      case certificateElementCapability.fillable:
        can = CertificateElementCapabilityManager.FILLABLE_CONTROLS.includes(type);
        break
      case certificateElementCapability.imageable:
        can = CertificateElementCapabilityManager.IMAGEABLE_CONTROLS.includes(type);
        break
      case certificateElementCapability.wysiwygable:
        can = CertificateElementCapabilityManager.WYSIWYGABLE_CONTROLS.includes(type);
        break
      case certificateElementCapability.relativelyAlignable:
        can = CertificateElementCapabilityManager.RELATIVELY_ALIGNABLE_CONTROLS.includes(type);
        break
      case certificateElementCapability.widthable:
        can = CertificateElementCapabilityManager.WIDTHABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.repeatable:
        can = CertificateElementCapabilityManager.REPEATABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.paddingable:
        can = CertificateElementCapabilityManager.PADDINGABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.marginable:
        can = CertificateElementCapabilityManager.MARGINABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.outlineThicknessable:
        can = CertificateElementCapabilityManager.OUTLINE_THICKNESSABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.lineable:
        can = CertificateElementCapabilityManager.LINEABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.mergeable:
        can = CertificateElementCapabilityManager.MERGEABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.labelable:
        can = CertificateElementCapabilityManager.LABELABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.previewable:
        can = CertificateElementCapabilityManager.PREVIEWABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.pageSizeable:
        can = CertificateElementCapabilityManager.PAGESIZEABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.layoutDraggable:
        can = CertificateElementCapabilityManager.LAYOUT_DRAGGABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.pageMarginable:
        can = CertificateElementCapabilityManager.Page_MARGINABLE_CONTROLS.includes(type);
        break;
      case certificateElementCapability.nonDisplayLayoutable:
        can = CertificateElementCapabilityManager.NON_DISPLAY_LAYOUT_CONTROLS.includes(type);
        break;
      case certificateElementCapability.pageNumberable:
        can = CertificateElementCapabilityManager.PAGE_NUMBERABLE_CONTROLS.includes(type);
        break;
      default:
        assertNever(duty);
        can = false;
        break;
    }
    CertificateElementCapabilityManager.log(`Type ${certificateElementType[type]} ${can ? 'can' : 'can\'t'} ${certificateElementCapability[duty]}`);
    return can;
  }

  static addDefaultProperties(el, json = {}) {
    if (el.can(certificateElementCapability.dimensionable)) {
      el.defineProperty('x', json["x"] || 0);
      el.defineProperty('y', json["y"] || 0);
      el.defineProperty('scale_x', json["scale_x"] || 1);
      el.defineProperty('scale_y', json["scale_y"] || 1);
    }
    if (el.can(certificateElementCapability.sizeable)) {

      let width = el.parent.cellWidth - 15 || 250
      let height = el.parent.cellHeight - 20 || 100

      if (el.type === certificateElementType.DynamicList || el.type === certificateElementType.DynamicModeDynamicList) {
        width = 500
        height = 120
      } 

      el.defineProperty('width', json["width"]  || width);
      el.defineProperty('height', json["height"] || height);
    }
    if (el.can(certificateElementCapability.rotateable)) {
      el.defineProperty('rotation', json["rotation"] || 0);
    }
    if (el.can(certificateElementCapability.opacityAble)) {
      el.defineProperty('c_opacity', json["c_opacity"] || 1);
    }
    if (el.can(certificateElementCapability.fillable) || el.type === certificateElementType.Divider) {
      // dividers are initialized as black with 100% opacity
      const defaultColor = el.type === certificateElementType.Divider ? "rgba(0, 0, 0, 1)" : null;
      el.defineProperty("fill", defaultColor || json["fill"] || null);
    }
    if (el.can(certificateElementCapability.dynamicListable)) {
      el.defineProperty('dynamic_list_client_id', json['dynamic_list_client_id'] || "");
      el.defineProperty('list_format', json['list_format'] || DynamicListFormatType.CommaSeparatedValues);
      el.defineProperty('line_spacing', json['line_spacing'] || 1.0);
      el.defineProperty('list_item_spacing', json['list_item_spacing'] || 1.0);
      el.defineProperty('font', json['font'] || FontType.TimesNewRoman);
      el.defineProperty('font_size', json['font_size'] || 12);
      el.defineProperty('list_order', json['list_order'] || DynamicListOrderType.Numeric);
      el.defineProperty('sub_input_client_id', json['sub_input_client_id'] || "");
      el.defineProperty('bullet_style', json['bullet_style'] || DynamicListBulletStyle.Circle);
    }
    if (el.can(certificateElementCapability.dynamicImageable)) {
      el.defineProperty('underlying_variable', json['underlying_variable'] || '');
    }
    if (el.can(certificateElementCapability.wysiwygable)) {
      el.defineProperty('html', json["html"] || '<p>Some text here</p>');
    }
    if (el.can(certificateElementCapability.imageable)) {
      el.defineProperty('file_upload_id', json["file_upload_id"]);
    }
    if (el.can(certificateElementCapability.relativelyAlignable)) {
      const shouldDefaultToMiddle = [
        certificateElementType.Grid,
        certificateElementType.Stack,
        certificateElementType.Divider,
      ].includes(el.type);
      const horizontalDefault = shouldDefaultToMiddle ? HorizontalAlignment.Middle : HorizontalAlignment.Left;
      el.defineProperty("horizontal_alignment", horizontalDefault);
      if (el.type !== certificateElementType.Divider) {
        el.defineProperty("vertical_alignment", VerticalAlignment.Top);
      }
    }
    if (el.can(certificateElementCapability.widthable)) {
      let width = el.width;
      if (el.type === certificateElementType.Grid) width = Math.max(el.initialGridWidth, 100);
      if (el.type === certificateElementType.Stack) width = Math.max(el.initialGridWidth, 100);
      if (el.type === certificateElementType.Divider) width = Math.max(el.dividerWidth, 0);
      el.defineProperty('width', json["width"] || width || 150);
    }
    if (el.can(certificateElementCapability.repeatable)) {
      el.defineProperty('is_repeatable', json['is_repeatable'] || false);
      el.defineProperty('repeatable_input_id', json['repeatable_input_id']);

    }
    if (el.can(certificateElementCapability.paddingable)) {
      el.defineProperty('padding_top', json['padding_top'] || 10);
      el.defineProperty('padding_bottom', json['padding_bottom'] || 10);
      el.defineProperty('padding_left', json['padding_left'] || 10);
      el.defineProperty('padding_right', json['padding_right'] || 10);
    }
    if (el.can(certificateElementCapability.pageMarginable)) {
      el.defineProperty('page_margin_top', 25);
      el.defineProperty('page_margin_bottom', 25);
      el.defineProperty('page_margin_left',  25);
      el.defineProperty('page_margin_right', 25);
    }
    if (el.can(certificateElementCapability.marginable)) {
      const defaultHorizontalMargin = el.type === certificateElementType.Grid ? 10 : 0;
      el.defineProperty('horizontal_cell_margin', json['horizontal_cell_margin'] || defaultHorizontalMargin);
      el.defineProperty('vertical_cell_margin', json['vertical_cell_margin'] || 10);
    }
    if (el.can(certificateElementCapability.outlineThicknessable)) {
      el.defineProperty('outline_thickness', json['outline_thickness'] || 0);
    }
    if (el.can(certificateElementCapability.lineable)) {
      el.defineProperty('line_style', json["line_style"] || 1);
      el.defineProperty('line_thickness', json["line_thickness"] || 1);
    }
    if (el.can(certificateElementCapability.mergeable)) {
      el.defineProperty("column_span", 1)
      el.defineProperty("row_span", 1)
      el.defineProperty("parent_cell_client_id", null)
    }
    if (el.can(certificateElementCapability.labelable)) {
      el.defineProperty("label_title", null)
    }

    if (el.can(certificateElementCapability.pageSizeable)) {
      el.defineProperty("page_size", CertificateSize.Letter)
      el.defineProperty("page_orientation", CertificateOrientation.Portrait)
    }

    if (el.can(certificateElementCapability.pageNumberable)) {
      el.defineProperty('include_page_numbers', json["include_page_numbers"] || false);
    }
  }

  private static log(message: string) {
    if (this.debug) {
      console.log(`DEBUG: CertificateElementCan: ${message}`);
    }
  }
}